module.exports = __webpack_public_path__ + "assets/media/s11.fa503e65.mp3";